import { addInvestmentProjectSaga } from './addInvestmentProject'
import { editInvestmentProjectSaga } from './editInvestmentProject'
import { getAllInvestmentProjectSaga } from './getAllInvestmentProject'
import { deleteInvestmentProjectSaga } from './deleteInvestmentProject'

const InvestmentProjectsSagas = [
    addInvestmentProjectSaga,
    getAllInvestmentProjectSaga,
    editInvestmentProjectSaga,
    deleteInvestmentProjectSaga,
]

export default InvestmentProjectsSagas
